import reward from "./reward";
import users from "./users"

export default {
    namespaced: true,

    modules: {
        reward,
        users
    },
};
